import React, {Component} from "react";
import Input from "../../../components/textbox/Input";
import Button from "../../../components/button/Button";
import {withTranslation} from "react-i18next";
import StatoInvioPremalServices from "../../../services/StatoInvioPremalServices";
import Calendar from "../../../components/calendar/Calendar";
import Autocomplete from "../../../components/autocomplete/Autocomplete";
import Utils from "../../../utils/Utils";
import Select from "../../../components/select/Select";
import CheckBox from "../../../components/checkbox/CheckBox";
import RadioButton from "../../../components/radiobutton/RadioButton";
import styles from "./StatoInvioPremalNav.module.css";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import toasterConfig from "../../../config/toasterConfig";
import Spinner from "../../../components/spinner/Spinner";


class StatoInvioPremalNav extends Component {

    state = {
        rows: [],
        exportFiltri: {
            dataDa: '',
            dataA: '',
            nonInviate: false,
            inviate: false,
            reinviate: false
        }
    }

    constructor(props) {
        super(props);
        this.createFilters = this.createFilters.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.riceviValoreExport = this.riceviValoreExport.bind(this)
        this.pulisciTutto = this.pulisciTutto.bind(this)
        this.handleExportFlussi = this.handleExportFlussi.bind(this)
        this.onClickApplicaFiltri = this.onClickApplicaFiltri.bind(this)
    }

    componentDidMount() {
        sessionStorage.setItem("pathProvenienza", "/" + this.props.pathProvenienza.value)
        this.createFilters()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        sessionStorage.setItem("pathProvenienza", "/" + this.props.pathProvenienza.value)
        if (prevProps != this.props) {
            this.createFilters()
        }
    }

    riceviValore(field, event) {
        let stato = this.props.filtri.stato
        stato[field] = event.target.value
        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})
        this.createFilters()
    }

    riceviValoreExport(field, event) {
        let exportFiltri = {...this.state.exportFiltri}
        if (event.target.value === "true") {
            exportFiltri[field] = true
        } else if (event.target.value === "false") {
            exportFiltri[field] = false
        } else {
            exportFiltri[field] = event.target.value
        }
        this.setState({exportFiltri})
    }

    aggiungiToaster(text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now()
        })
    }

    pulisciTutto() {
        let stato = this.props.filtri.stato
        let rows = this.props.filtri.rows
        for (let key in stato) {
            for (let i = 0; i < rows.length; i++) {
                if (rows[i][key] && key === rows[i][key].id && !rows[i][key].disabled) {
                    stato[key] = ""
                } else if ((rows[i]["dataInvio"] || rows[i]["dataSegnalazione"]) && key === "tipoData") {
                    stato[key] = ""
                }
            }
        }
        this.props.filtri.setStatePadre({filtri: stato})
        sessionStorage.removeItem("filtriMonitoraggio")
        this.createFilters()
        this.props.filtri.applicaFiltri(stato)
    }

    async handleExportFlussi() {
        try {
            this.setState({loading: true})
            const res = await StatoInvioPremalServices.getExportFlussiSegnalazioni(this.state.exportFiltri)
            if (res.status === 200) {
                Utils.downloadReport(res.data.stream, res.data.descrizione, "csv")
            }
            this.setState({loading: false})
        } catch (e) {
            this.setState({loading: false})
            return this.aggiungiToaster("Non sono presenti segnalazioni per il periodo selezionato");
        }

    }

    createFilters() {
        const rows = []
        const rowFiltriInfo = this.props.filtri.rows
        const {t} = this.props
        if (rowFiltriInfo) {
            for (let i = 0; i < rowFiltriInfo.length; i++) {
                let cols = []
                const rowFilterInfo = Object.values(rowFiltriInfo[i]).sort((a, b) => a.numeroCol < b.numeroCol ? -1 : 1)
                for (const filterInfo of rowFilterInfo) {
                    let filtro = (
                        filterInfo.tipo === "input" ?
                            <Input id={filterInfo.id} field={filterInfo.field} onChange={this.riceviValore}
                                   value={this.props.filtri.stato[filterInfo.field]}
                                   placeholder={t(filterInfo.text)}
                            />
                            :
                            filterInfo.tipo === "radio" ?
                                <RadioButton id={filterInfo.id}
                                             name={filterInfo.field}
                                             label={filterInfo.text}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                             smallLabel={true}
                                             value={filterInfo.value}
                                             checked={this.props.filtri.stato[filterInfo.field] == filterInfo.value}
                                ></RadioButton>
                                :
                                filterInfo.tipo === "autocomplete" ?
                                    <Autocomplete id={filterInfo.id} onChange={this.riceviValore}
                                                  field={filterInfo.field}
                                                  keyField={filterInfo.keyField}
                                                  disabled={filterInfo.disabled}
                                                  descriptionField={filterInfo.descriptionField}
                                                  suggestionField={filterInfo.suggestionField}
                                                  value={this.props.filtri.stato[filterInfo.field]}
                                                  placeholder={t(filterInfo.text)}
                                                  suggestions={filterInfo.suggestions}/>
                                    :
                                    filterInfo.tipo === "selectAutocomplete" ?
                                        <div>
                                            {filterInfo.text &&
                                                <h6>{filterInfo.text}</h6>
                                            }
                                            <SelectAutocomplete
                                                id={filterInfo.id}
                                                onChange={this.riceviValore}
                                                newSelect={true}
                                                field={filterInfo.field}
                                                placeholder={filterInfo.placeholder}
                                                value={this.props.filtri.stato[filterInfo.field]}
                                                functionMap={Utils.mapToArray(filterInfo.suggestions).map((oggetto) => {
                                                    return (
                                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                                })}
                                                disabled={filterInfo.disabled}
                                            />
                                        </div>
                                        :
                                        filterInfo.tipo === "select" ?
                                            <Select
                                                old={true}
                                                value={this.props.filtri.stato[filterInfo.field]}
                                                field={filterInfo.field}
                                                id={filterInfo.id}
                                                newSelect={true}
                                                defaultSelect={filterInfo.defaultSelect}
                                                onChange={this.riceviValore}
                                                functionMap={Utils.mapToArray(filterInfo.suggestions).map((oggetto) => {
                                                    let option = oggetto.cssClass && oggetto.cssClass === "stickerYellow" ?
                                                        <option
                                                            value={oggetto.codice}>{oggetto.descrizione} &#128993;</option> : oggetto.cssClass &&
                                                        oggetto.cssClass === "stickerGreen" ? <option
                                                                value={oggetto.codice}>{oggetto.descrizione} &#128994;</option> :
                                                            oggetto.cssClass && oggetto.cssClass === "trattino" ?
                                                                <option
                                                                    value={oggetto.codice}>{oggetto.descrizione} &#9866;</option> :
                                                                <option
                                                                    value={oggetto.codice}>{oggetto.descrizione}</option>
                                                    return (option)
                                                })}
                                            /> :
                                            filterInfo.tipo === "data" ?
                                                <Calendar id={filterInfo.id}
                                                          value={this.props.filtri.stato[filterInfo.field]}
                                                          field={filterInfo.field}
                                                          onChange={this.riceviValore}
                                                          newCalendar={true}
                                                          placeholder={filterInfo.placeholder ? filterInfo.placeholder : ""}
                                                          errorMessage={this.props.filtri.stato[filterInfo.field] && Utils.isDateInValid(this.props.filtri.stato[filterInfo.field]) ? "Data non valida" : ""}
                                                          error={Utils.isDateInValid(Utils.transformDateForBackend(this.props.filtri.stato[filterInfo.field]), "-") &&
                                                              this.props.filtri.stato[filterInfo.field] !== ""}
                                                /> : <div></div>
                    )
                    cols.push(filtro)
                }
                const filters = []
                for (const filtro of cols) {
                    filters.push(
                        <div className="col">
                            {filtro}
                        </div>
                    )
                }
                const row = (
                    <div className="row mt-3">
                        {filters}
                    </div>
                )
                rows.push(row)
            }
        }
        // sessionStorage.removeItem("filtriMonitoraggio")
        return this.setState({rows})
    }

    onClickApplicaFiltri() {
        let stato = this.props.filtri.stato
        sessionStorage.setItem("filtriMonitoraggio", JSON.stringify(stato))
        this.props.filtri.applicaFiltri(stato)
    }

    renderExportFilters() {
        const dateRow = (
            <div className="row">
                <div className="col">
                    <Calendar id="dataDa"
                              value={this.state.exportFiltri.dataDa}
                              field="dataDa"
                              onChange={this.riceviValoreExport}
                              newCalendar={true}
                              placeholder="Data da"
                              errorMessage={this.state.exportFiltri.dataDa && Utils.isDateInValid(this.state.exportFiltri.dataDa) ? "Data non valida" : ""}
                              error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.exportFiltri.dataDa), "-") &&
                                  this.state.exportFiltri.dataDa !== ""}
                    />
                </div>
                <div className="col">
                    <Calendar id="dataA"
                              value={this.state.dataA}
                              field="dataA"
                              onChange={this.riceviValoreExport}
                              newCalendar={true}
                              placeholder="Data a"
                              errorMessage={this.state.exportFiltri.dataA && Utils.isDateInValid(this.state.exportFiltri.dataA) ? "Data non valida" : ""}
                              error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.exportFiltri.dataA), "-") &&
                                  this.state.exportFiltri.dataA !== ""}
                    />
                </div>
            </div>
        )
        const nonInviateRow = (
            <div className="row">
                <CheckBox id="nonInviate"
                          checked={this.state.exportFiltri.nonInviate}
                          text="Segnalazioni eleggibili nel periodo di riferimento"
                          onChange={this.riceviValoreExport}
                          newCheckbox={true}
                          fontColor={"#1b7ea9"}
                          fontSize={"16px"}
                />
            </div>
        )
        const inviateRow = (
            <div className="row">
                <CheckBox id="inviate"
                          checked={this.state.exportFiltri.inviate}
                          text="Segnalazioni inviate nel periodo di riferimento"
                          onChange={this.riceviValoreExport}
                          newCheckbox={true}
                          fontColor={"#1b7ea9"}
                          fontSize={"16px"}
                />
            </div>
        )
        const reinviateRow = (
            <div className="row">
                <CheckBox id="reinviate"
                          checked={this.state.exportFiltri.reinviate}
                          text="Segnalazioni reinviate nel periodo di riferimento"
                          onChange={this.riceviValoreExport}
                          newCheckbox={true}
                          fontColor={"#1b7ea9"}
                          fontSize={"16px"}
                />
            </div>
        )

        return [dateRow, nonInviateRow, inviateRow, reinviateRow]
    }

    render() {
        const {t} = this.props
        const whiteButton = "btnWhite"

        const exportFilterRows = this.renderExportFilters()
        return (<>
                <div className={styles.responsive}>
                    <div className="row pb-3">
                        <div className="col">
                            <p style={{fontWeight: "bold", fontSize: "22px", marginLeft: "3rem", marginTop: "1rem"}}>
                                Filtra per:
                            </p>
                        </div>
                        <div className="col-5 pr-4">
                            {this.state.rows}

                            <div className="row d-flex justify-content-center mt-2">
                                <div className="mr-1 col-lg-3 ml-1">
                                    <Button id={"idButtonApplica"} text={t("Buttons.applica")}
                                            className={[whiteButton, "col-lg-12"].join(" ")}
                                            style={{height: "2rem", fontSize: "15px"}}
                                            onClick={this.onClickApplicaFiltri}
                                    />
                                </div>
                                <div className="mr-1 col-lg-3 ml-1">
                                    <Button id={"idButtonRimuovi"} text={t("Buttons.rimuovi")}
                                            className={[whiteButton, "col-lg-12"].join(" ")}
                                            style={{height: "2rem", fontSize: "15px"}}
                                            onClick={this.pulisciTutto}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={["col-5 px-4 mt-3", styles.leftDivider].join(" ")}>
                            {exportFilterRows}

                            <div className="row d-flex justify-content-center">
                                <div className="col-7">
                                    <Button id="idButtonExport" text="Richiedi export"
                                            className="btnBlu col-10"
                                            onClick={this.handleExportFlussi}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loading ? (<div><Spinner/></div>) : (<></>)}
            </>
        );
    }

}

export default withTranslation('common')(StatoInvioPremalNav);
